import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import moment from "moment-timezone";
import React, { Component } from "react";
import { Link } from "react-router-dom";

class AdminUserTableContainer extends Component {
  state = {
    users: [],
    searchResult: undefined,
    email: "",
    liveLink: "",
    liveLinkSearchResult: undefined,
    tournamentId: "",
    tournamentIdSearchResult: undefined,
    tournamentName: "",
    tournamentNameSearchResults: [],
    invoiceNumber: "",
    invoiceNumberSearchResults: undefined,
  };

  UNSAFE_componentWillMount = () => {
    // if (this.props.isPSD) {
    //   window.firebase
    //     .firestore()
    //     .collection("users")
    //     .where("isPSD", "==", true)
    //     .get()
    //     .then((querySnapshot) => {
    //       let users = [];
    //       querySnapshot.forEach((doc) => {
    //         let user = doc.data();
    //         user["id"] = doc.id;
    //         users.push(user);
    //       });
    //       this.setState({ users: users });
    //     });
    // } else if (this.props.isSporta) {
    //   window.firebase
    //     .firestore()
    //     .collection("users")
    //     .where("isSporta", "==", true)
    //     .get()
    //     .then((querySnapshot) => {
    //       let users = [];
    //       querySnapshot.forEach((doc) => {
    //         let user = doc.data();
    //         user["id"] = doc.id;
    //         users.push(user);
    //       });
    //       this.setState({ users: users });
    //     });
    // } else {
    //   window.firebase
    //     .firestore()
    //     .collection("users")
    //     .orderBy("registeredOn", "desc")
    //     .limit(100)
    //     .get()
    //     .then((querySnapshot) => {
    //       let users = [];
    //       querySnapshot.forEach((doc) => {
    //         let user = doc.data();
    //         user["id"] = doc.id;
    //         users.push(user);
    //       });
    //       this.setState({ users: users });
    //     });
    // }
  };

  searchByEmail = () => {
    if (!this.state.email) {
      this.setState({ searchResult: [] });
      return;
    }

    const searchTerm = this.state.email.toLowerCase();

    window.firebase
      .firestore()
      .collection("users")
      .orderBy("email")
      .startAt(searchTerm)
      .endAt(searchTerm + "\uf8ff")
      .limit(10)
      .get()
      .then((querySnapshot) => {
        let users = [];
        querySnapshot.forEach((doc) => {
          let userDoc = doc.data();
          userDoc["id"] = doc.id;
          users.push(userDoc);
        });
        this.setState({ searchResult: users });
      });
  };

  searchByTournamentId = () => {
    if (!this.state.tournamentId) {
      this.setState({ tournamentIdSearchResult: undefined });
    } else {
      window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.state.tournamentId)
        .get()
        .then((doc) => {
          let user = {};
          if (doc.exists) {
            let uid = doc.data().uid;
            window.firebase
              .firestore()
              .collection("users")
              .doc(uid)
              .get()
              .then((userDoc) => {
                if (userDoc.exists) {
                  let userDocData = userDoc.data();
                  userDocData["id"] = userDoc.id;
                  user = userDocData;
                }
                this.setState({ tournamentIdSearchResult: user });
              });
          } else {
            this.setState({ tournamentIdSearchResult: user });
          }
        });
    }
  };

  searchByLiveLink = () => {
    if (!this.state.liveLink) {
      this.setState({ liveLinkSearchResult: undefined });
    } else {
      window.firebase
        .firestore()
        .collection("tournaments")
        .where("liveLink", "==", this.state.liveLink)
        .get()
        .then((querySnapshot) => {
          let tournament = {};
          querySnapshot.forEach((doc) => {
            let tournamentDoc = doc.data();
            tournamentDoc["id"] = doc.id;
            tournament = tournamentDoc;
          });
          this.setState({ liveLinkSearchResult: tournament });
        });
    }
  };

  searchByTournamentName = () => {
    if (!this.state.tournamentName) {
      this.setState({ tournamentNameSearchResults: [] });
      return;
    }

    window.firebase
      .firestore()
      .collection("tournamentSearch")
      .where(
        "keywords",
        "array-contains",
        this.state.tournamentName.toLowerCase(),
      )
      .limit(25)
      .get()
      .then((querySnapshot) => {
        let tournaments = querySnapshot.docs.map(async (doc) => {
          let tournament = doc.data();
          tournament["id"] = doc.id;

          // Fetch the actual tournament document to get the uid
          const tournamentDoc = await window.firebase
            .firestore()
            .collection("tournaments")
            .doc(doc.id)
            .get();

          if (tournamentDoc.exists) {
            tournament["uid"] = tournamentDoc.data().uid;
          }

          return tournament;
        });

        Promise.all(tournaments).then((resolvedTournaments) => {
          resolvedTournaments.sort((a, b) => b.date - a.date);
          this.setState({ tournamentNameSearchResults: resolvedTournaments });
        });
      });
  };

  searchByInvoiceNumber = async () => {
    if (!this.state.invoiceNumber) {
      this.setState({ invoiceNumberSearchResults: undefined });
      return;
    }

    const querySnapshot = await window.firebase
      .firestore()
      .collection("upgrades")
      .where("invoiceStatus", "==", this.state.invoiceNumber.trim())
      .limit(25)
      .get();

    const invoiceSearchResults = await Promise.all(
      querySnapshot.docs.map(async (doc) => {
        const upgrade = doc.data();
        const result = {
          id: doc.id,
          invoiceStatus: upgrade.invoiceStatus || "",
          invoiceId: upgrade.invoiceId || "",
          invoiceDate:
            upgrade.timestamp && upgrade.timestamp.toDate
              ? moment(upgrade.timestamp.toDate()).format("DD-MM-YYYY")
              : "",
          tournamentId: upgrade.tournamentId || "",
          uid: upgrade.uid || "",
          tournamentName: "",
          companyName: upgrade.companyName || "",
          asACompany: upgrade.asACompany === true,
          firstName: upgrade.firstName || "",
          lastName: upgrade.lastName || "",
        };

        if (upgrade.tournamentId) {
          const tournamentDoc = await window.firebase
            .firestore()
            .collection("tournaments")
            .doc(upgrade.tournamentId)
            .get();

          if (tournamentDoc.exists) {
            const tournament = tournamentDoc.data();
            result.tournamentName = tournament.name || "";
            if (!result.uid) {
              result.uid = tournament.uid || "";
            }
          }
        }

        return result;
      }),
    );

    this.setState({ invoiceNumberSearchResults: invoiceSearchResults });
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      // enter was pressed
      e.preventDefault();
      this.searchByEmail(e);
    }
  };

  handleKeyDownTournamentId = (e) => {
    if (e.keyCode === 13) {
      // enter was pressed
      e.preventDefault();
      this.searchByTournamentId(e);
    }
  };

  handleKeyDownLiveLink = (e) => {
    if (e.keyCode === 13) {
      // enter was pressed
      e.preventDefault();
      this.searchByLiveLink(e);
    }
  };

  handleKeyDownTournamentName = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.searchByTournamentName();
    }
  };

  handleKeyDownInvoiceNumber = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.searchByInvoiceNumber();
    }
  };

  render() {
    let users = this.state.users;
    if (this.props.isPSD || this.props.isSporta) {
      users.sort((a, b) => {
        return b.registeredOn - a.registeredOn;
      });
    }
    return (
      <div style={{ width: "100%", marginTop: 10 }}>
        {!this.props.isPSD && !this.props.isSporta && (
          <div style={{ margin: "0 15px" }}>
            <TextField
              autoFocus
              fullWidth
              margin="normal"
              placeholder="Email address"
              label="Search user by email address"
              value={this.state.email}
              onKeyDown={this.handleKeyDown}
              onChange={(e) => {
                this.setState({ email: e.target.value });
              }}
              variant="outlined"
            />
            <Button
              variant="contained"
              color="primary"
              onClick={this.searchByEmail}
            >
              Search
            </Button>
            {this.state.searchResult !== undefined && (
              <div>
                <br />
                Search result:
                <br />
                {Array.isArray(this.state.searchResult) &&
                this.state.searchResult.length > 0 ? (
                  <Table>
                    <TableBody>
                      {this.state.searchResult.map((user) => (
                        <TableRow key={user.id}>
                          <TableCell>
                            {moment
                              .unix(user.registeredOn)
                              .format("D MMMM YYYY HH:mm")}
                          </TableCell>
                          <TableCell>{user.firstName || ""}</TableCell>
                          <TableCell>{user.email}</TableCell>
                          <TableCell>{user.id}</TableCell>
                          <TableCell>
                            <Link to={"/admin/" + user.id}>Details</Link>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  "Nothing found"
                )}
              </div>
            )}
            <TextField
              fullWidth
              margin="normal"
              placeholder="tournamentId"
              label="Search user by tournamentId"
              value={this.state.tournamentId}
              onKeyDown={this.handleKeyDownTournamentId}
              onChange={(e) => {
                this.setState({ tournamentId: e.target.value });
              }}
              variant="outlined"
            />
            <Button
              variant="contained"
              color="primary"
              onClick={this.searchByTournamentId}
            >
              Search
            </Button>
            {this.state.tournamentIdSearchResult !== undefined && (
              <div>
                <br />
                Search result:
                <br />
                {this.state.tournamentIdSearchResult.email ? (
                  <Table>
                    <TableBody>
                      <TableRow key={this.state.tournamentIdSearchResult.id}>
                        <TableCell>
                          {moment
                            .unix(
                              this.state.tournamentIdSearchResult.registeredOn,
                            )
                            .format("D MMMM YYYY HH:mm")}
                        </TableCell>
                        <TableCell>
                          {this.state.tournamentIdSearchResult.firstName || ""}
                        </TableCell>
                        <TableCell>
                          {this.state.tournamentIdSearchResult.email}
                        </TableCell>
                        <TableCell>
                          {this.state.tournamentIdSearchResult.id}
                        </TableCell>
                        <TableCell>
                          <Link
                            to={
                              "/admin/" + this.state.tournamentIdSearchResult.id
                            }
                          >
                            Details
                          </Link>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                ) : (
                  "Nothing found"
                )}
              </div>
            )}
            <TextField
              fullWidth
              margin="normal"
              placeholder="Livelink"
              label="Search tournament by livelink"
              value={this.state.liveLink}
              onKeyDown={this.handleKeyDownLiveLink}
              onChange={(e) => {
                this.setState({ liveLink: e.target.value });
              }}
              variant="outlined"
            />
            <Button
              variant="contained"
              color="primary"
              onClick={this.searchByLiveLink}
            >
              Search
            </Button>
            {this.state.liveLinkSearchResult !== undefined && (
              <div>
                <br />
                Search result:
                <br />
                {this.state.liveLinkSearchResult.id ? (
                  <Table>
                    <TableBody>
                      <TableRow key={this.state.liveLinkSearchResult.id}>
                        <TableCell>
                          {moment
                            .unix(this.state.liveLinkSearchResult.date)
                            .format("D MMMM YYYY HH:mm")}
                        </TableCell>
                        <TableCell>
                          <Link
                            to={
                              "/tournament/" +
                              this.state.liveLinkSearchResult.id
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {this.state.liveLinkSearchResult.name || ""}
                          </Link>
                        </TableCell>
                        <TableCell>
                          <Link
                            to={"/admin/" + this.state.liveLinkSearchResult.uid}
                          >
                            User
                          </Link>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                ) : (
                  "Nothing found"
                )}
              </div>
            )}
            <TextField
              fullWidth
              margin="normal"
              placeholder="Tournament name"
              label="Search tournament by name"
              value={this.state.tournamentName}
              onKeyDown={this.handleKeyDownTournamentName}
              onChange={(e) => {
                this.setState({ tournamentName: e.target.value });
              }}
              variant="outlined"
            />
            <Button
              variant="contained"
              color="primary"
              onClick={this.searchByTournamentName}
            >
              Search
            </Button>
            {this.state.tournamentNameSearchResults.length > 0 && (
              <div>
                <br />
                Search result:
                <br />
                <Table>
                  <TableBody>
                    {this.state.tournamentNameSearchResults.map(
                      (tournament) => (
                        <TableRow key={tournament.id}>
                          <TableCell>
                            {moment
                              .unix(tournament.date)
                              .format("D MMMM YYYY HH:mm")}
                          </TableCell>
                          <TableCell>
                            <Link
                              to={"/tournament/" + tournament.id}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {tournament.name || ""}
                            </Link>
                          </TableCell>
                          <TableCell>
                            <Link to={"/admin/" + tournament.uid}>User</Link>
                          </TableCell>
                        </TableRow>
                      ),
                    )}
                  </TableBody>
                </Table>
              </div>
            )}
            <TextField
              fullWidth
              margin="normal"
              placeholder="Invoice number"
              label="Search tournament by invoice number"
              value={this.state.invoiceNumber}
              onKeyDown={this.handleKeyDownInvoiceNumber}
              onChange={(e) => {
                this.setState({ invoiceNumber: e.target.value });
              }}
              variant="outlined"
            />
            <Button
              variant="contained"
              color="primary"
              onClick={this.searchByInvoiceNumber}
            >
              Search
            </Button>
            {this.state.invoiceNumberSearchResults !== undefined && (
              <div>
                <br />
                Search result:
                <br />
                {Array.isArray(this.state.invoiceNumberSearchResults) &&
                this.state.invoiceNumberSearchResults.length > 0 ? (
                  <Table>
                    <TableBody>
                      {this.state.invoiceNumberSearchResults.map((result) => (
                        <TableRow key={result.id}>
                          <TableCell>
                            {result.invoiceId ? (
                              <a
                                href={`https://app.jortt.nl/new_invoices/show/pp/aggregate_id/${result.invoiceId}/`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {result.invoiceStatus}
                                {result.invoiceDate
                                  ? ` (${result.invoiceDate})`
                                  : ""}
                              </a>
                            ) : (
                              <>
                                {result.invoiceStatus}
                                {result.invoiceDate
                                  ? ` (${result.invoiceDate})`
                                  : ""}
                              </>
                            )}
                          </TableCell>
                          <TableCell>
                            {(result.asACompany
                              ? result.companyName
                              : `${result.firstName || ""} ${
                                  result.lastName || ""
                                }`.trim()) || "-"}
                          </TableCell>
                          <TableCell>
                            {result.tournamentId ? (
                              result.tournamentName ? (
                                <Link
                                  to={"/tournament/" + result.tournamentId}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {result.tournamentName}
                                </Link>
                              ) : (
                                `Tournament deleted (${result.tournamentId})`
                              )
                            ) : (
                              "-"
                            )}
                          </TableCell>
                          <TableCell>
                            {result.uid ? (
                              <Link to={"/admin/" + result.uid}>User</Link>
                            ) : (
                              "-"
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  "Nothing found"
                )}
              </div>
            )}
          </div>
        )}
        <br />
        <br />
        <br />
        {/* {!this.props.isPSD && !this.props.isSporta && (
          <div style={{ margin: "0 15px" }}>Laatste 100 accounts:</div>
        )} */}
        {/* <Table>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>
                  {moment.unix(user.registeredOn).format("D MMMM YYYY HH:mm")}
                </TableCell>
                <TableCell>{user.firstName || ""}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.id}</TableCell>
                <TableCell>
                  <Link to={"/admin/" + user.id}>Details</Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table> */}
      </div>
    );
  }
}

export default AdminUserTableContainer;
